import React, { useRef } from "react";
import { useDispatch } from "react-redux";
import {
  AddUpdateInsurerPayableAction,
  AddUpdatePayableAction,
  GetAppointmentInsurerAction,
  GetFinanceQcAction,
  GetInsurerBillingClientAction,
  GetQCApprovalDetailsNetworkAction,
} from "../../../redux/actions/PayoutAction";
import { getSnackbarSuccess, isLoadingAction } from "../../../Utils/helper";

export const CreatePayablePopup = ({
  qcFinancePage,
  payableData,
  setPayabelData,
  rowData,
  searchFilter,
  firstPageData,
  insBillingPage,
}) => {
  const dispatch = useDispatch();
  const ref = useRef();
  const handleSubmit = async () => {
    let apiId = payableData?.map((ele) => {
      return { appointmentId: ele?.appointmentId };
    });
    let prvId = payableData?.map((ele) => {
      return { providerId: ele?.providerId };
    });
    console.log("payableData",payableData)
    let clId = payableData.map((ele) => {
      return { clientId: ele?.clientId };
    });
    let res;
    if(rowData?.detailType === "FinanceQC" || rowData?.detailType === "ProviderQC"){
      if (qcFinancePage === "firstPage") {
        res = await dispatch(
          AddUpdatePayableAction({
            providerIds: prvId,
            year: payableData[0]?.year,
            month: payableData[0]?.month,
            RequestId: payableData[0]?.requestID,
            qcType: "PROVIDERWISE",
            BusinessType: payableData[0]?.buType,
            // BusinessType: searchFilter?.BusinessType,
          })
        );
        if (res) {
          await dispatch(
            GetFinanceQcAction({
              ...searchFilter,
              sessionId: firstPageData?.sessionID,
              ticketId: firstPageData?.requestID,
              providerId: firstPageData?.providerId,
            })
          );
        }
      } else if (qcFinancePage === "secondPage") {
        res = await dispatch(
          AddUpdatePayableAction({
            providerIds: prvId,
            appointmentIds: apiId,
            year: payableData[0]?.year,
            month: payableData[0]?.month,
            requestId: payableData[0]?.requestID,
            qcType: "APPOINTMENTWISE",
            BusinessType: payableData[0]?.buType,
            // BusinessType: searchFilter?.BusinessType,
          })
        );
        if (res) {
          dispatch(
            GetQCApprovalDetailsNetworkAction({
              ...searchFilter,
              sessionId: rowData?.sessionId,
              ticketId: rowData?.requestID,
              providerId: rowData?.providerId,
            })
          );
        }
      }
  
      if (res?.data?.status === true) {
        ref.current.click();
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
        setPayabelData([]);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    } 
    if ( rowData?.detailType === "InsurerBillingQC"){
     
      if (insBillingPage === "firstPage") {
        res = await dispatch(
          AddUpdateInsurerPayableAction({
            providerIds: null,
            year: payableData[0]?.year,
            month: payableData[0]?.month,
            RequestId: payableData[0]?.requestID,
            qcType: "PROVIDERWISE",
            BusinessType: payableData[0]?.buType,
            clientIds:clId
            // BusinessType: searchFilter?.BusinessType,
          })
        );
        if (res) {
          await dispatch(
            GetInsurerBillingClientAction({
              ...searchFilter,
              sessionId: firstPageData?.sessionID,
              ticketId: firstPageData?.requestID,
              providerId:null
            })
          );
        }
      } else if (insBillingPage === "secondPage") {
        console.log("hii",{
              providerIds: null,
              appointmentIds: apiId,
              year: payableData[0]?.year,
              month: payableData[0]?.month,
              requestId: payableData[0]?.requestID,
              qcType: "APPOINTMENTWISE",
              BusinessType: payableData[0]?.buType,
              clientIds:clId
              // BusinessType: searchFilter?.BusinessType,
            })
        res = await dispatch(
          AddUpdateInsurerPayableAction({
            providerIds: null,
            appointmentIds: apiId,
            year: payableData[0]?.year,
            month: payableData[0]?.month,
            requestId: payableData[0]?.requestID,
            qcType: "APPOINTMENTWISE",
            BusinessType: payableData[0]?.buType,
            clientIds:clId
            // BusinessType: searchFilter?.BusinessType,
          })
        );
        if (res) {
          dispatch(
            GetAppointmentInsurerAction({
              ...searchFilter,
              sessionId: rowData?.sessionId,
              ticketId: rowData?.requestID,
              providerId: rowData?.providerId,
              clientId:rowData?.clientId
            })
          );
        }
      }
  
      if (res?.data?.status === true) {
        ref.current.click();
        getSnackbarSuccess("success", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
        setPayabelData([]);
      } else {
        getSnackbarSuccess("error", res?.data?.message, dispatch);
        isLoadingAction(false, dispatch);
      }
    }
   
  };

  return (
    <>
      <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content" style={{ borderRadius: "1em" }}>
          <div className=" modal-body-active-popup popup-text">
            Are you sure you want to create Payable ?
          </div>
          <div className="modal-footer modal-footer-active-popup">
            <button
              type="button"
              className="btn btn-primary noshow_disable"
              style={{ width: "90px" }}
              onClick={handleSubmit}
            >
              Yes
            </button>
            <button
              type="button"
              className="btn btn-primary btn-logout-no"
              aria-label="Close"
              data-bs-dismiss="modal"
              ref={ref}
              //   onClick={handleClose}
            >
              No
            </button>
          </div>
        </div>
      </div>
    </>
  );
};
